/* ============================================================
   TARZ by Tahira — Theme JavaScript
   ============================================================ */

/* ─── Sidebar Toggle ─────────────────────────────────────── */
function toggleMobileMenu() {
  const sidebar = document.getElementById('sidebarNav');
  const btn = document.getElementById('menuToggle');
  if (!sidebar) return;
  const open = sidebar.classList.toggle('mobile-open');
  if (btn) btn.setAttribute('aria-expanded', open);
  document.body.classList.toggle('sidebar-open', open);
}

function closeSidebar() {
  const sidebar = document.getElementById('sidebarNav');
  const btn = document.getElementById('menuToggle');
  if (!sidebar) return;
  sidebar.classList.remove('mobile-open', 'open');
  if (btn) btn.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('sidebar-open');
}

document.addEventListener('DOMContentLoaded', () => {

  /* ─── Hamburger button ──────────────────────────────────── */
  const menuToggle = document.getElementById('menuToggle');
  if (menuToggle) {
    menuToggle.addEventListener('click', toggleMobileMenu);
  }

  /* ─── Sidebar Accordion ─────────────────────────────────── */
  document.querySelectorAll('.sidebar-menu-item').forEach(item => {
    const link = item.querySelector('.sidebar-menu-link');
    const submenu = item.querySelector('.sidebar-submenu');
    if (!link || !submenu) return;
    link.addEventListener('click', e => {
      e.preventDefault();
      item.classList.toggle('expanded');
    });
  });

  /* ─── Hero Slider ───────────────────────────────────────── */
  const slider = document.getElementById('heroSlider');
  if (slider) {
    const slides = Array.from(slider.querySelectorAll('.hero-slide'));
    const dots = Array.from(slider.querySelectorAll('.hero-dot'));
    let active = 0, timer;

    const show = (n) => {
      slides[active].classList.remove('active');
      if (dots[active]) { dots[active].classList.remove('active'); dots[active].setAttribute('aria-selected', 'false'); }
      active = (n + slides.length) % slides.length;
      slides[active].classList.add('active');
      if (dots[active]) { dots[active].classList.add('active'); dots[active].setAttribute('aria-selected', 'true'); }
    };

    const restart = () => { clearInterval(timer); timer = setInterval(() => show(active + 1), 4200); };

    const prevBtn = document.getElementById('heroPrev');
    const nextBtn = document.getElementById('heroNext');
    if (prevBtn) prevBtn.addEventListener('click', () => { show(active - 1); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { show(active + 1); restart(); });
    dots.forEach(d => d.addEventListener('click', () => { show(+d.dataset.index); restart(); }));

    if (slides.length > 1) restart();
  }

  /* Wishlist hearts are handled by tarz-engagement.js (persistent). */

  /* ─── Filter Chips (homepage) ───────────────────────────── */
  document.querySelectorAll('.filter-chip').forEach(chip => {
    chip.addEventListener('click', () => {
      document.querySelectorAll('.filter-chip').forEach(c => {
        c.classList.remove('active');
        c.setAttribute('aria-pressed', 'false');
      });
      chip.classList.add('active');
      chip.setAttribute('aria-pressed', 'true');
    });
  });

  /* ─── Collection Filter Panel Toggle ───────────────────── */
  const filterToggle = document.getElementById('filterToggle');
  const filterPanel = document.getElementById('filterPanel');
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', () => {
      const open = filterPanel.classList.toggle('open');
      filterToggle.setAttribute('aria-expanded', open);
      filterPanel.setAttribute('aria-hidden', !open);
    });
  }

  /* ─── Filter Group Accordion ────────────────────────────── */
  document.querySelectorAll('.filter-group-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.filter-group');
      if (group) group.classList.toggle('collapsed');
    });
  });

  /* ─── Collection View Toggle (2-col / 4-col) ────────────── */
  const viewToggle = document.getElementById('viewToggle');
  const collGrid = document.getElementById('collGrid');
  if (viewToggle && collGrid) {
    viewToggle.addEventListener('click', () => {
      collGrid.classList.toggle('two-col');
    });
  }

  /* ─── Cart Quantity Controls ────────────────────────────── */
  document.querySelectorAll('.qty-dec, .qty-inc').forEach(btn => {
    btn.addEventListener('click', () => {
      const line = btn.dataset.line;
      const input = document.querySelector(`.qty-input[data-line="${line}"]`);
      if (!input) return;
      const delta = btn.classList.contains('qty-inc') ? 1 : -1;
      const newQty = Math.max(1, parseInt(input.value, 10) + delta);
      input.value = newQty;
      updateCartItem(line, newQty);
    });
  });

  /* ─── Add to Cart (AJAX) ────────────────────────────────── */
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(productForm);
      const submitBtn = productForm.querySelector('[type="submit"]');
      // Write into the label span when present so icons inside the button survive
      const labelEl = submitBtn ? (submitBtn.querySelector('#addToCartLabel') || submitBtn) : null;
      const originalText = labelEl ? labelEl.textContent : '';
      if (labelEl) { labelEl.textContent = 'Adding…'; submitBtn.disabled = true; }
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
        if (res.ok) {
          const cartRes = await fetch('/cart.js');
          const cartData = await cartRes.json();
          updateCartCount(cartData.item_count);
          if (labelEl) { labelEl.textContent = 'Added!'; }
          if (window.tarzToast) window.tarzToast('Added to bag');
          setTimeout(() => { if (labelEl) { labelEl.textContent = originalText; submitBtn.disabled = false; } }, 1500);
        }
      } catch (err) {
        if (labelEl) { labelEl.textContent = originalText; submitBtn.disabled = false; }
      }
    });
  }

});

/* ─── Update Cart Count Badge ───────────────────────────── */
function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count], #cartCount').forEach(badge => {
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  });
  if (window.TarzCart?.refresh) window.TarzCart.refresh();
}

/* ─── Update Cart Item Quantity (AJAX) ──────────────────── */
async function updateCartItem(line, quantity) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    const cart = await res.json();
    updateCartCount(cart.item_count);
  } catch (err) {}
}
